__turbopack_context__.v({
  "ivBodyText": "ivLoungeSectionLayout-module__DhuHpG__ivBodyText",
  "ivContentShell": "ivLoungeSectionLayout-module__DhuHpG__ivContentShell",
  "ivSectionHeading": "ivLoungeSectionLayout-module__DhuHpG__ivSectionHeading",
  "ivSectionLabel": "ivLoungeSectionLayout-module__DhuHpG__ivSectionLabel",
  "ivSectionRootDark": "ivLoungeSectionLayout-module__DhuHpG__ivSectionRootDark",
  "ivSectionRootWhite": "ivLoungeSectionLayout-module__DhuHpG__ivSectionRootWhite",
});
